"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.normalizeSlashChars = normalizeSlashChars;
function normalizeSlashChars(input, isStartingSlashRequired = undefined, isEndingSlashRequired = undefined) {
  let result = input;
  if (isStartingSlashRequired !== undefined) {
    while (result[0] === '/') {
      result = result.slice(1);
    }
  }
  if (isEndingSlashRequired !== undefined) {
    while (result.at(-1) === '/') {
      result = result.slice(0, -1);
    }
  }
  if (isStartingSlashRequired) {
    result = `/${result}`;
  }
  if (isEndingSlashRequired) {
    result = `${result}/`;
  }
  return result;
}
//# sourceMappingURL=normalizeSlashChars.js.map